export const operatorMap: {
  key?: string;
  value: string;
  label: string;
  category: string;
}[] = [
  { key: "text_eq", value: "$eq", label: "filter.eq", category: "text" },
  { value: "$ne", label: "filter.ne", category: "text" },
  { value: "$iLike", label: "filter.like", category: "text" },
  { value: "$notILike", label: "filter.notLike", category: "text" },
  { key: "number_eq", value: "$eq", label: "=", category: "number" },
  { key: "number_gte", value: "$gte", label: ">=", category: "number" },
  { value: "$gt", label: ">", category: "number" },
  { key: "number_ne", value: "$ne", label: "<>", category: "number" },
  { key: "number_lte", value: "$lte", label: "<=", category: "number" },
  { value: "$lt", label: "<", category: "number" },
  { key: "date_lt", value: "$lt", label: "filter.lt", category: "date" },
  { key: "date_gt", value: "$gt", label: "filter.gt", category: "date" },
  // { value: "$in", label: "", category: "text" }
  { value: "$in", label: "", category: "multi" },
];
